<template>
  <div class="guideContainer">
    <div class="text"> {{ msg }} </div>
    <div v-if="btns.includes('purchase')" class="btnType01 first" @click.prevent="showVoucher">구매하기</div>
    <div v-if="btns.includes('change')" class="btnType01 sec" @click.prevent="showSetting">화질변경</div>
  </div>
</template>

<script>
export default {
  name: 'PurchaseGuide',
  props: {
    msg: {
      type: String
    },
    btns: {
      type: String
    },
    contentInfo: {
      type: Object
    },
    programId: {
      type: String
    },
    contentId: {
      type: String
    },
    contentType: {
      type: String
    },
  },
  methods: {
    showVoucher () {
      //this.$router.push({ name: 'voucher' })
      this.$router.push({
        name: 'voucher_popup_new_for_app',
        params: {
         'cpid': this.contentInfo.cpid,
         'channelid': this.contentInfo.channelid,
         'programid': this.programId,
         'contentid': this.contentId,
         'contenttype': this.contentType
       }
     })
    },
    showSetting () {
      this.$parent.openSetting()
    }
  }
}
</script>

<style>
  .guideContainer { width: 100%; position: relative; height: 81px; }
  .guideContainer .text { position: absolute; top:21px; left:20px; color:#a5a5a5; font-size: 14px; width: 270px;}
  .guideContainer .first { position: absolute; top:12px; right:20px;  }
  .guideContainer .sec { position: absolute; top:44px; right:20px;  }
  .btnType01 {  height: 24px; text-align:center; line-height:24px; color: #ffffff; font-size: 12px; border-radius: 12px; border: 1px solid #fff;padding: 0 10px 0 10px;}
</style>
